export type TimePeriod = 'annual' | 'threeYear' | 'fiveYear' | 'tenYear';

export type PracticeType = 
  | 'mentalHealth' 
  | 'primaryCare' 
  | 'medicalAesthetics' 
  | 'ivInfusion' 
  | 'multiService'
  | 'hormoneOptimization'
  | 'urgentCare';

export interface SavingsResult {
  npcAnnualCost: number;
  npcTotalCost: number;
  techOwnedAnnualCost: number;
  techOwnedTotalCost: number;
  mdOwnedAnnualCost: number;
  mdOwnedTotalCost: number;
  vsTechOwned: {
    annual: number;
    total: number;
    percentage: number;
  };
  vsMdOwned: {
    annual: number;
    total: number;
    percentage: number;
  };
  timePeriod: TimePeriod;
  months: number;
}

export const practiceTypeLabels: Record<PracticeType, string> = {
  mentalHealth: 'Mental Health',
  primaryCare: 'Primary Care',
  medicalAesthetics: 'Medical Aesthetics',
  ivInfusion: 'IV Infusion',
  multiService: 'Multi-Service',
  hormoneOptimization: 'Hormone Optimization',
  urgentCare: 'Urgent Care'
};

export const timePeriodLabels: Record<TimePeriod, string> = {
  annual: '1 Year',
  threeYear: '3 Years',
  fiveYear: '5 Years',
  tenYear: '10 Years'
};

export const timePeriodMonths: Record<TimePeriod, number> = {
  annual: 12,
  threeYear: 36,
  fiveYear: 60,
  tenYear: 120
};
